import React from "react";
import Radio from "@mui/material/Radio";
import { Box, Typography } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useSelector } from "react-redux";

export default function SubscriptionCards({
  CheckTypeFunc,
  setshowsubTypeFunc,
  selectSubType,
  setselectSubType

}) {

  const { selectedDishes } = useSelector((state) => state.dishes);
  // const updatedSelectedDishes = selectedDishes.map(dish => ({
  //   ...dish,
  //   pricePerDay: 10// Add your price value here for each object
  // }));
  console.log("selectedDishes", selectedDishes);
  // const menuCart = useSelector((state) => state.cart);

  // Extract an array of prices using map
  const pricesArray = selectedDishes.map((item) =>
    // console.log("ite", item),
    item?.dish.price * item.quantity
  )
    ;
  console.log("pricesArray", pricesArray)
  // Calculate the sum of all prices using reduce
  let totalPricePerDay = pricesArray.reduce(
    (accumulator, currentPrice) => accumulator + currentPrice,
    0
  );
  console.log("totalPricePerDay", totalPricePerDay)
  let weeklyPrice = Math.ceil(totalPricePerDay * 7 * 0.95);
  let monthlyPrice = Math.ceil(totalPricePerDay * 30 * 0.9);

  totalPricePerDay = Math.ceil(totalPricePerDay);
  const handleChange = (e) => {
    console.log(e.target.value);
    setselectSubType(e.target.value)
  };
  return (
    <>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="female"
          name="radio-buttons-group"
          onChange={handleChange}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                border: "1px solid #559A95",
                borderRadius: "4px",
                width: { lg: "416px", md: "416px", sm: "380px", xs: "360px" },
                height: "94px",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Box pl="10px">
                    {/* <Radio {...controlProps("c")} color="success" /> */}
                    <FormControlLabel
                      value="Monthly Subscription"
                      control={
                        <Radio
                          onClick={() => {
                            CheckTypeFunc(true);
                            setshowsubTypeFunc(false);
                          }}
                        />
                      }
                    />{" "}
                  </Box>

                  <Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "20px",
                            md: "20px",
                            sm: "18px",
                            xs: "14px",
                          },
                          fontWeight: "600",
                        }}
                      >
                        Monthly Subscription
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "16px",
                            md: "16px",
                            sm: "14px",
                            xs: "12px",
                          },
                          fontWeight: "400",
                          color: "#545359",
                        }}
                      >
                        With 10% discount
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "92px",
                    height: "52px",
                    border: "1px solid #E1E1E6",
                    mr: "12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "20px",
                        md: "20px",
                        sm: "18px",
                        xs: "14px",
                      },
                      fontWeight: "600",
                    }}
                  >
                    ${monthlyPrice}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                border: "1px solid #E1E1E6",
                borderRadius: "4px",
                width: { lg: "416px", md: "416px", sm: "380px", xs: "360px" },
                height: "94px",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Box pl="10px">
                    <FormControlLabel
                      value="Weekly Subscription"
                      control={
                        <Radio
                          onClick={() => {
                            CheckTypeFunc(true);
                            setshowsubTypeFunc(false);
                          }}
                        />
                      }
                    />
                  </Box>

                  <Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "20px",
                            md: "20px",
                            sm: "18px",
                            xs: "14px",
                          },
                          fontWeight: "600",
                        }}
                      >
                        Weekly Subscription
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "16px",
                            md: "16px",
                            sm: "14px",
                            xs: "12px",
                          },
                          fontWeight: "400",
                          color: "#545359",
                        }}
                      >
                        With 5% discount
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "92px",
                    height: "52px",
                    border: "1px solid #E1E1E6",
                    mr: "12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "20px",
                        md: "20px",
                        sm: "18px",
                        xs: "14px",
                      },
                      fontWeight: "600",
                    }}
                  >
                    ${weeklyPrice}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                border: "1px solid #E1E1E6",
                borderRadius: "4px",
                width: { lg: "416px", md: "416px", sm: "380px", xs: "360px" },
                height: "94px",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Box pl="10px">
                    <FormControlLabel
                      value="Single Order"
                      control={
                        <Radio
                          onClick={() => {
                            CheckTypeFunc(true);
                            setshowsubTypeFunc(false);
                          }}
                        />
                      }
                    />{" "}
                  </Box>

                  <Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "20px",
                            md: "20px",
                            sm: "18px",
                            xs: "14px",
                          },
                          fontWeight: "600",
                        }}
                      >
                        Single Order
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "16px",
                            md: "16px",
                            sm: "14px",
                            xs: "12px",
                          },
                          fontWeight: "400",
                          color: "#545359",
                        }}
                      >
                        One time order only
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "92px",
                    height: "52px",
                    border: "1px solid #E1E1E6",
                    mr: "12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "20px",
                        md: "20px",
                        sm: "18px",
                        xs: "14px",
                      },
                      fontWeight: "600",
                    }}
                  >
                    ${totalPricePerDay}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                border: "1px solid #E1E1E6",
                borderRadius: "4px",
                width: { lg: "416px", md: "416px", sm: "380px", xs: "360px" },
                height: "94px",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <Box pl="10px">
                    {/* <Radio {...controlProps("c")} color="success" /> */}
                    <FormControlLabel
                      value="Custom Subscription"
                      control={
                        <Radio
                          onClick={() => {
                            CheckTypeFunc(true);
                            setshowsubTypeFunc(false);
                          }}
                        />
                      }
                    />{" "}
                  </Box>

                  <Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "20px",
                            md: "20px",
                            sm: "18px",
                            xs: "14px",
                          },
                          fontWeight: "600",
                        }}
                      >
                        Custom Subscription
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "16px",
                            md: "16px",
                            sm: "14px",
                            xs: "12px",
                          },
                          fontWeight: "400",
                          color: "#545359",
                        }}
                      >
                        Customise your order days
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </RadioGroup>
      </FormControl>
    </>
  );
}
